import { FocusSDK as focusSDK, isFocusEnv } from "@/utils";
import { isSameDay } from "./date";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { get } from "lodash";
import WNBS_PN from "@/assets/images/im/icon-ai-wnbs.png";
import ROBOT_PN from "@/assets/images/im/icons-ai-robot-app.png";

const REACT_APP_RUNTIME =
  (window as any)?._BTS_CONFIG?.REACT_APP_RUNTIME || process.env.REACT_APP_RUNTIME;

/**
 *
 * 获取web端使用的颜色值
 * @export
 * @param {string} color
 * @returns
 */
export function pickHexColor(color: string) {
  if (color && color.length === 8) {
    return `#${color.slice(2)}`;
  } else if (color && color.length === 6) {
    return `#${color}`;
  }
  return color;
}
export function pickHexColorWithOutPre(color: string) {
  if (color && color.length === 8) {
    return `${color.slice(2)}`;
  } else if (color && color.length === 6) {
    return `${color}`;
  }
  return color;
}
// 互联网下apps不替换
function isNotReplaceUrlList(url: string) {
  const list = [
    "jzb.beijing.egov.cn/admin",
    "jzb.beijing.egov.cn/client",
    "apps.jzb.beijing.egov.cn"
  ];
  let findItem = list.find((item) => {
    return url.indexOf(item) > -1;
  });
  return !!findItem;
}

export function changeSingleDomain(urlParam: any, currentHostParam: string) {
  const app_runtime = REACT_APP_RUNTIME;
  const not_single = process.env.REACT_APP_NOT_SINGLE === "true";
  if (not_single || (app_runtime !== "mebjJZB" && app_runtime !== undefined)) {
    return urlParam;
  }
  if (typeof urlParam !== "string") {
    return urlParam;
  }
  if (!/\.e?gov\.cn|\.jdcloud\.com/.test(urlParam)) {
    return urlParam;
  }
  // const replaceArray = [
  //     'oss.jzb.beijing.gov.cn',
  //     'eefs.jzb.beijing.gov.cn',
  //     'janus.jzb.beijing.gov.cn',
  //     'qr.jzb.beijing.gov.cn',
  //     'im-gate.jzb.beijing.gov.cn',
  //     'im-ws.jzb.beijing.gov.cn',
  //     'joyspace.jzb.beijing.gov.cn',
  //     'apijoyspace.jzb.beijing.gov.cn',
  //     'otjoyspace.jzb.beijing.gov.cn',
  //     'ca.jzb.beijing.gov.cn',
  //     'jzb-oss-test.jdcloud.com',
  //     'jzb-eefs-test.jdcloud.com',
  //     'jzb-janus-test.jdcloud.com',
  //     'jzb-qr-test.jdcloud.com',
  //     'jzb-im-gate-test.jdcloud.com',
  //     'jzb-im-ws-test.jdcloud.com',
  //     'jzb-joyspace-test.jdcloud.com',
  //     'jzb-apijoyspace-test.jdcloud.com',
  //     'jzb-otjoyspace-test.jdcloud.com',
  // ];
  let currentHost = currentHostParam;
  if (!currentHostParam) {
    currentHost = focusSDK.getMeMainEntry();
  }
  let url = urlParam;
  if (url) {
    try {
      let currentHostUrl = new URL(currentHost);
      // 当前网站主域名
      const currentHostName = currentHostUrl.hostname;
      let baseUrl = url.indexOf("http") !== 0 ? currentHost : undefined;
      let newUrl = new URL(url, baseUrl);
      if (newUrl) {
        let hostname = newUrl.hostname;
        // 传进来的地址与主域名相同，不替换
        if (currentHostName.indexOf(hostname) > -1) {
          return url;
        }
        // 仅替换指定域名
        if (
          !/^(jzb-)?(oss|eefs|janus|qr|im-gate|im-ws|joyspace|apijoyspace|otjoyspace|ca)[\.-]/.test(
            hostname
          )
        ) {
          return url;
        }
        const prodRegex = /\.(jzb\.beijing\.e?gov\.cn)/;
        const testPreRegex = /^jzb-\w+-/;
        let prefixPath = "";
        let newHostName = "";
        // 替换仅跟传进来的地址有关
        const matchArr = hostname.match(prodRegex);
        if (matchArr && matchArr.length > 1 && matchArr[1]) {
          newHostName = matchArr[1];
          prefixPath = hostname.replace(newHostName, "").replace(".", "");
        } else if (testPreRegex.test(hostname)) {
          const prefixHost = hostname.split(".")[0];
          newHostName =
            prefixHost.indexOf("-test") > -1
              ? "jzb-test.jdcloud.com"
              : prefixHost.indexOf("-pre") > -1
              ? "jzb-pre.jdcloud.com"
              : currentHostName;
          prefixPath = prefixHost.replace("jzb-", "").replace("-test", "").replace("-pre", "");
        }

        if (prefixPath) {
          url = url
            .replace(hostname, `${newHostName}/${prefixPath}`)
            .replace(`\/${prefixPath}\/${prefixPath}\/`, `\/${prefixPath}\/`);
          return url
            .replace(/(jdcloud\.com|e?gov\.cn)\/apijoyspace\//, "$1/joyspace-api/")
            .replace(/(jdcloud\.com|e?gov\.cn)\/otjoyspace\//, "$1/joyspace-ot/")
            .replace(/(jdcloud\.com|e?gov\.cn)\/qr\//, "$1/qr-code/");
        }
        return url;
      }
    } catch (e) {
      console.log("单域名替换异常", url, e);
      return url;
    }
  }
}

// 仅支持互联网访问的页面
const isGovPage = (url: string) => {
  const list = [
    /jzb\.beijing\.e?gov\.cn\/home/,
    /focus-desktop\.s3\.cn-north-1\.jdcloud-oss\.com\/jzb-home/
  ];
  const findItem = list.find((item) => {
    return item.test(url);
  });
  return !!findItem;
};

// 根据host切换不同的url host
export function changeEgovUrl(urlParam: any) {
  let currentHost = focusSDK.getMeMainEntry();
  const replaceUrlStr = process.env.REACT_APP_REPLACE_URLS || "";
  if (replaceUrlStr) {
    const replaceUrls = replaceUrlStr.split(",");
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < replaceUrls.length; i++) {
      if (
        urlParam &&
        typeof urlParam === "string" &&
        !currentHost?.includes(replaceUrls[i]) &&
        urlParam?.includes(replaceUrls[i])
      ) {
        return urlParam.replace(replaceUrls[i], currentHost);
      }
    }
  }
  const app_runtime = REACT_APP_RUNTIME;
  if (app_runtime !== "mebjJZB" && app_runtime !== undefined) {
    return urlParam;
  }
  if (typeof urlParam !== "string") {
    return urlParam;
  }
  let url = urlParam;
  if (isGovPage(url)) {
    url = url.replace("beijing.egov.cn", "beijing.gov.cn");
    return url;
  }
  // 非政务外网下
  if (currentHost.indexOf("beijing.egov.cn") === -1) {
    // gov环境下将egov的切换为gov
    if (currentHost.indexOf("beijing.gov.cn") > -1 && !isNotReplaceUrlList(url)) {
      url = url.replace("beijing.egov.cn", "beijing.gov.cn");
    }
    return changeSingleDomain(url, currentHost);
  }

  let egovAddressMap = {
    "eefs.jzb.beijing.gov.cn": "eefs.jzb.beijing.egov.cn",
    "jzb-eefs.jdcloud.com": "eefs.jzb.beijing.egov.cn",
    "oss.jzb.beijing.gov.cn": "oss.jzb.beijing.egov.cn",
    "jzb-oss.jdcloud.com": "oss.jzb.beijing.egov.cn",
    "joyspace.jzb.beijing.gov.cn": "joyspace.jzb.beijing.egov.cn",
    "jzb-joyspace.jdcloud.com": "joyspace.jzb.beijing.egov.cn",
    "apijoyspace.jzb.beijing.gov.cn": "apijoyspace.jzb.beijing.egov.cn",
    "jzb-apijoyspace.jdcloud.com": "apijoyspace.jzb.beijing.egov.cn",
    "jzb.beijing.gov.cn": "jzb.beijing.egov.cn",
    "jzb.jdcloud.com": "jzb.beijing.egov.cn",
    "wps.jzb.beijing.gov.cn": "wps.jzb.beijing.egov.cn",
    "app.jzb.beijing.gov.cn": "app.jzb.beijing.egov.cn",
    "eepaas-public.s3.cn-north-1.jdcloud-oss.com": "oss.jzb.beijing.egov.cn",
    "focus-desktop.s3.cn-north-1.jdcloud-oss.com": "oss.jzb.beijing.egov.cn/focus-desktop",
    "s3.cn-north-1.jdcloud-oss.com": "oss.jzb.beijing.egov.cn"
  } as any;
  if (url) {
    try {
      let baseUrl = url.indexOf("http") !== 0 ? window.location?.origin : undefined;
      let newUrl = new URL(url, baseUrl);
      if (newUrl) {
        let hostname = newUrl.hostname;
        let newHost = egovAddressMap[hostname];
        if (newHost) {
          url = url.replace(hostname, newHost);
        }
      }
    } catch (e) {
      console.log("切换政务外网地址出异常", url, e);
      return changeSingleDomain(url, currentHost);
    }
  }
  return changeSingleDomain(url, currentHost);
}

export function changeGovUrl(urlParam: any) {
  const app_runtime = REACT_APP_RUNTIME;
  if (app_runtime !== "mebjJZB" && app_runtime !== undefined) {
    return urlParam;
  }
  if (typeof urlParam !== "string") {
    return urlParam;
  }
  let url = urlParam;
  let currentHost = focusSDK.getMeMainEntry();
  // 非政务外网下
  if (currentHost.indexOf("beijing.egov.cn") === -1) {
    return changeSingleDomain(url, currentHost);
  }
  let govAddressMap = {
    "eefs.jzb.beijing.egov.cn": "eefs.jzb.beijing.gov.cn",
    "oss.jzb.beijing.egov.cn": "oss.jzb.beijing.gov.cn",
    "joyspace.jzb.beijing.egov.cn": "joyspace.jzb.beijing.gov.cn",
    "jzb.beijing.egov.cn": "jzb.beijing.gov.cn",
    "app.jzb.beijing.egov.cn": "app.jzb.beijing.gov.cn"
  } as any;
  if (url) {
    try {
      let baseUrl = url.indexOf("http") !== 0 ? window.location?.origin : undefined;
      let newUrl = new URL(url, baseUrl);
      if (newUrl) {
        let hostname = newUrl.hostname;
        let newHost = govAddressMap[hostname];
        if (newHost) {
          url = url.replace(hostname, newHost);
        }
      }
    } catch (e) {
      console.log("切换互联网地址出异常", url, e);
      return changeSingleDomain(url, currentHost);
    }
  }
  return changeSingleDomain(url, currentHost);
}

// 将HTML转义为实体 (& —— 和号，其实体名称为：【&amp;】  其实体编号为：【&#38;】)
export function htmlEscape(html: string): string {
  const elem = document.createElement("div");
  const txt = document.createTextNode(html);
  elem.appendChild(txt);
  return elem.innerHTML;
}

// 将实体转回为HTML
export function htmlUnescape(str: string): string {
  const elem = document.createElement("div");
  elem.innerHTML = str;
  return elem.innerText || elem.textContent || "";
}

// http卡片链接url判断
export function judgeHttpCardLinkUrl(url: string) {
  const reg1 = /jzb\.beijing\.e?gov\.cn\/client/;
  const reg2 = /jzb([\s\S]*)\.jdcloud.com\/client/;
  // 京办互联网主域名跳转到京办官网不再是京办页面,后续请改为运营后台配置
  // const list = ['https://jzb.beijing.egov.cn', 'http://jzb.beijing.egov.cn'];
  if (reg1.test(url) || reg2.test(url)) {
    return false;
  }
  // const target = list.find((item: string) => item === url);
  // if (target) {
  //     return false;
  // }
  return true;
}

export function maskName(name: string) {
  if (!name) {
    return name || "";
  }
  if (name.length > 1) {
    return name.slice(0, 1) + "*";
  }
  return name;
}

export function isEqualArray(arr1: any[], arr2: any[]) {
  return (
    Array.isArray(arr1) &&
    Array.isArray(arr2) &&
    arr1.length === arr2.length &&
    JSON.stringify(arr1) === JSON.stringify(arr2)
  );
}

export function crossAppSwitch(module: string, currentEmployee?: any, runEnv?: AppRuntimeEnv) {
  const { REACT_APP_CROSS_APP_SWITCH = "1111110111111001" } = process.env;

  const config = (
    (window as any)?._BTS_CONFIG?.REACT_APP_CROSS_APP_SWITCH || REACT_APP_CROSS_APP_SWITCH
  )?.split("") as any[];
  switch (module) {
    case "message": {
      return !!Number(config[0]);
    }
    case "joywork": {
      if (currentEmployee && runEnv) {
        return currentEmployee?.teamId === runEnv?.bjwpConfig.teamId ? false : !!Number(config[1]);
      }
      return !!Number(config[1]);
    }
    case "calendar": {
      return !!Number(config[2]);
    }
    case "joyspace": {
      return !!Number(config[3]);
    }
    case "groupSpace": {
      return !!Number(config[4]);
    }
    case "threeApp": {
      return !!Number(config[5]);
    }
    case "meeting": {
      return !!Number(config[6]);
    }
    case "help": {
      return !!Number(config[7]);
    }
    case "supervise": {
      return !!Number(config[8]);
    }
    case "addressBook": {
      return !!Number(config[9]);
    }
    case "login": {
      return !!Number(config[10]);
    }
    // 网络检测
    case "netWork": {
      return !!Number(config[11]);
    }
    case "calendarWeather": {
      return !!Number(config[12]);
    }
    // 知识库
    case "wiki": {
      return !!Number(config[13]);
    }
    // 消息擦除
    case "messageRecord": {
      return !!Number(config[14]);
    }
    // 自注册
    case "selfRegistration": {
      return !!Number(config[15]);
    }
    // 语音转文字
    case "turnVoiceToText": {
      return !!Number(config[16]);
    }
  }
}

export function isJSON(str: any) {
  if (typeof str === "string") {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  return false;
}

export enum CloseMethod {
  NO_CLOSE = 1,
  MANUAL_CLOSE = 2,
  AUTO_CLOSE = 3,
  COMM_CLOSE = 4
}
export const KEY_PROMPT_VER = "KEY_PROMPT_VER";
export const getShowTipLocal = (data: any) => {
  try {
    if (!data) {
      return true;
    }
    const res = typeof data === "string" ? JSON.parse(data) : data;
    const isSame = isSameDay(parseInt(res.date, 10), new Date().getTime());
    return !isSame;
  } catch (e) {
    return false;
  }
};

// 判断是否在可视区
export function isInViewPortOfOne(wrap: any, el: any) {
  if (!wrap) {
    return false;
  }
  const { top, bottom } = wrap.getBoundingClientRect();
  let rect = el.getBoundingClientRect();
  let elTop = top - rect.top;
  let elBottom = bottom - rect.bottom;
  let clientHeight = wrap.offsetHeight;
  return elBottom >= 0 && elTop < clientHeight;
}
export const KEY_TEAMCONFIG_VER = "KEY_TEAMCONFIG_VER";

// 获取最终配置
export const getRealConfig = (teamConfig: any, moduleConfig: any, key: string) => {
  if (teamConfig && teamConfig[key]) {
    if (isNaN(teamConfig[key])) {
      return teamConfig[key];
    } else {
      return Number(teamConfig[key]);
    }
  } else {
    return moduleConfig[key];
  }
};

export const PC_SIDE_ITEM_MAX = 21;
export const PC_SIDE_ITEM_NUM = (window as any)?._BTS_CONFIG?.PC_SIDE_ITEM_NUM || 6;
export const PC_CUSTOM_SIDEBAR_KEY = "customPcSidebar";
export const PC_SIDEBAR_KEY = "pcSidebar";
export const PC_SIDEBAR_KEY_VERSION = "_version";
// 获取导航配置内容
export const getPcSideConfig = (
  teamConfig: any,
  options: {
    key?: string;
    pKey?: string;
    getDefault?: boolean;
    type?: string;
  } = {}
) => {
  const { key = "", pKey = PC_CUSTOM_SIDEBAR_KEY, getDefault = true, type = "object" } = options;
  let value = null;
  let pcSide = get(teamConfig || {}, pKey);
  if (!pcSide && getDefault) {
    pcSide = get(teamConfig || {}, PC_SIDEBAR_KEY);
  }
  try {
    if (pcSide) {
      value = typeof pcSide === "string" ? JSON.parse(pcSide) : pcSide;
      if (value) {
        return key ? get(value, key) : value;
      }
    }
  } catch (e) {}
  return type === "string" ? "" : {};
};

export const getRoutePathByRole = (role: string) => {
  switch (role) {
    case "messages": {
      return "/messages";
    }
    case "calendar": {
      return "/calendar";
    }
    case "ebook": {
      return "/address_list";
    }
    case "thirdApp": {
      return "/third_apps";
    }
    case "meeting": {
      return "/meeting";
    }
    default:
      return "";
  }
};

// 文件控制
export const KEY_FILE_SECURITY_CONF = isFocusEnv()
  ? "fileSecurityControl-pc"
  : "fileSecurityControl-web";
export const DEFAULT_FILE_SECURITY_CONF = {
  enable: 1, // 1-可用，0-不可用
  fileTagList: [
    {
      tagId: 0,
      tagName: "普通文件",
      tagDesc: "允许接收方另存为、下载、转存到、转发、在线预览、上传群空间、添加到任务、添加到日程"
    },
    {
      tagId: 1,
      tagName: "内部文件",
      tagDesc: "允许接收方另存为、下载、转发、在线预览"
    },
    {
      tagId: 2,
      tagName: "领导批示",
      tagDesc: "允许接收方另存为、下载、转发、在线预览"
    }
  ],
  env: {
    ca: [
      {
        tagId: 0, // 普通文件
        operationPermissions: {
          send: 1,
          saveAs: 1,
          download: 1,
          tranferTo: 1,
          forward: 1,
          addToSchedule: 1,
          addToWork: 1,
          uploadToGroupSpace: 1,
          onlinePreview: 1
        }
      },
      {
        tagId: 1, // 内部
        operationPermissions: {
          send: 1,
          saveAs: 1,
          download: 1,
          tranferTo: 0,
          forward: 1,
          addToSchedule: 0,
          addToWork: 0,
          uploadToGroupSpace: 0,
          onlinePreview: 1
        }
      },
      {
        tagId: 2, // 领导
        operationPermissions: {
          send: 1,
          saveAs: 1,
          download: 1,
          tranferTo: 0,
          forward: 1,
          addToSchedule: 0,
          addToWork: 0,
          uploadToGroupSpace: 0,
          onlinePreview: 1
        }
      }
    ],
    normal: [
      {
        tagId: 0, // 普通
        operationPermissions: {
          send: 1,
          saveAs: 1,
          download: 1,
          tranferTo: 1,
          forward: 1,
          addToSchedule: 1,
          addToWork: 1,
          uploadToGroupSpace: 1,
          onlinePreview: 1
        }
      },
      {
        tagId: 1, // 内部
        operationPermissions: {
          send: 1,
          saveAs: 0,
          download: 0,
          tranferTo: 0,
          forward: 0,
          addToSchedule: 0,
          addToWork: 0,
          uploadToGroupSpace: 0,
          onlinePreview: 0
        }
      },
      {
        tagId: 2, // 领导
        operationPermissions: {
          send: 1,
          saveAs: 0,
          download: 0,
          tranferTo: 0,
          forward: 0,
          addToSchedule: 0,
          addToWork: 0,
          uploadToGroupSpace: 0,
          onlinePreview: 0
        }
      }
    ]
  }
};

// 获取文件控制配置
export const getFileSecurityConfig = (teamConfig: any) => {
  const conf = get(teamConfig, KEY_FILE_SECURITY_CONF);
  if (!conf) {
    return {};
  }
  return typeof conf === "string" ? JSON.parse(conf) : conf;
};

// 获取文件控制标签列表
export const getFileSecurityTagList = (teamConfig: any) => {
  const conf = getFileSecurityConfig(teamConfig);
  if (!conf) {
    return {};
  }
  return get(conf, "fileTagList");
};

// 获取当前配置
export const getCurrentFileControls = (teamConfig: any, envName: string) => {
  const conf = getFileSecurityConfig(teamConfig);
  const list = get(conf, `env.${envName}`);
  return list;
};

// 获取当前发送控制
export const getCurrentFileSendControls = ({
  teamConfig,
  envName,
  controlList
}: {
  teamConfig: any;
  envName?: string;
  controlList?: any[];
}) => {
  if (!controlList && !(!!teamConfig && !!envName)) {
    return [];
  }
  const list = controlList
    ? controlList
    : !!teamConfig && !!envName
    ? getCurrentFileControls(teamConfig, envName)
    : [];
  const sends = list
    .filter((l: any) => get(l, "operationPermissions.send") === 1)
    .map((i: any) => i.tagId);
  const tags = getFileSecurityTagList(teamConfig) || [];
  return tags.filter((i: any) => sends.includes(i.tagId));
};

// 默认文件类型
export const getDefaultFileTag = (list: any[]) => {
  if (!list?.length) {
    return 0;
  }
  const id = get(list, "[0].tagId");
  return id;
};

// 默认文件类型
export const getFileTagById = (list: any[], id: number) => {
  if (!list?.length) {
    return {};
  }
  const tag = list.find((f) => f.tagId === id);
  return tag || {};
};

// 获取文件名
export const getFileTagName = ({ allName = true, fileTag, fileTagList, isEgovFile }: any) => {
  const tagNum = fileTag || 0;
  const tag = getFileTagById(fileTagList || [], tagNum);
  let name = tagNum === 0 && !isEgovFile ? "" : tag?.tagName || "";
  // if (allName) {
  //   name += `${name ? "-" : ""}${isEgovFile ? "政务外网" : "双网"}`;
  // }
  return name;
};

// 获取操作
export const getFileOperate = (operates: string[], controls: any[], tagId: number): string[] => {
  const authorityFile = controls?.find((i) => i.tagId === tagId);
  const operation = get(authorityFile, "operationPermissions") || {};
  const res: string[] = [];
  operates.forEach((key) => {
    const configKey = KEY_CONVERT[key];
    if (!configKey || operation[configKey] === 1) {
      res.push(key);
    }
  });
  return res;
};

export const getFileOperateAuthority = (
  operateName: string,
  controls: any[],
  tagId: number
): boolean => {
  const authorityFile = controls?.find((i) => i.tagId === tagId);
  const operation = get(authorityFile, `operationPermissions.${operateName}`) || 0;
  return operation === 1;
};

export const KEY_CONVERT: Record<string, string> = {
  "click-to-save": "download",
  "click-to-saveAs": "saveAs",
  "click-to-saveTo": "tranferTo",
  "click-to-wps-preview": "onlinePreview"
};

export const KEY_AI_LOCAL_MERGE = "aiMergeLocal";
export const KEY_AI_MERGE_RULE = "aiMergeRule";
export const DEFAULT_AI_MERGE_RULE = {
  regexRule:
    "^(?<![\\dA-Za-z.,~!、，。！])(([\\u4e00-\\u9fa5]{1,10})?((好[.,~!、，。！])|ok|ook|okk|好 的|好的|收到|明白|落实|支持|同意|可行|正确|照办|了解|好滴|好嘞|好哒|可以|是的|对的|好得|好呀|知晓|知悉|清楚|认可|认同|肯定|很棒|很赞|知道|满意|一定|完成|无误|合格|到位|充足|稳定|通过|已提交|已安排|已部署|已完成|已收到|已响应|已启动|已处理|已推进|已到位|已介入|已就绪|已核发|已更新|已消除|已恢复|已清零|已确认|没问题|百分百|并无异常|一切正常|坚决落实|坚决贯彻|准时反馈|立即处理|立即执行|立即整改|立即落实|马上处理|马上执行|马上解决|问题清零|响应及时|积极配合|严格执行|尽快完成|认真落实|立刻部署|即刻响应|及时反馈|目标达成|确保完成|坚决执行|坚定执行|保证完成|没有问题|处理完成|处理完毕|落到实处|完成任务|全员就位|全员在岗|开始实施|执行有力|全力配合|通力配合|全力保障|安排妥当|保障充分|全面排查)(了)?[.,~!、，。！]?([\\u4e00-\\u9fa5]{1,10})?){1,3}[.,~!、，。！]?$",
  posOne: ["好", "行", "成", "是", "对"],
  negWord: ["不", "未", "没", "无", "拒绝", "否", "难以", "很难"],
  negSuffix: ["？", "?", "吗", "嘛", "么"],
  doubleNeg: [
    "没问题",
    "没有问题",
    "无异常",
    "没有异常",
    "无误",
    "无延误",
    "无卡点",
    "没错",
    "没有异议",
    "无异议",
    "没有意见",
    "无意见",
    "没意见"
  ]
};

// 获取ai配置
export const getAIConfigData = (config: any, key: string) => {
  const data = get(config || {}, key);
  return data || {};
};

// 判断应用
export const getAppRuntimeName = () => {
  const app_runtime =
    (window as any)?._BTS_CONFIG?.REACT_APP_RUNTIME || process.env.REACT_APP_RUNTIME;
  return app_runtime;
};

export const isMebjJZB = () => {
  const name = getAppRuntimeName();
  return name && name === "mebjJZB";
};

export function compareVersions(v1: string, v2: string) {
  // 将版本号字符串按点号分割成数组
  const version1 = v1.replace(/v/gi, "").split(".").map(Number);
  const version2 = v2.replace(/v/gi, "").split(".").map(Number);
  // 确保两个版本号数组长度一致，短的版本号用0补齐
  const maxLength = Math.max(version1.length, version2.length);
  while (version1.length < maxLength) version1.push(0);
  while (version2.length < maxLength) version2.push(0);

  // 逐个比较版本号数组中的数字
  for (let i = 0; i < maxLength; i++) {
    if (version1[i] > version2[i]) return 1; // v1 大于 v2
    if (version1[i] < version2[i]) return -1; // v1 小于 v2
  }

  // 如果所有部分都相等，则版本号相等
  return 0;
}

export function getQueryString(src: string) {
  let searchParam = src?.split("?")?.[1];
  let hashIndex = searchParam.indexOf("#");
  if (hashIndex > 0) {
    searchParam = searchParam.substring(0, hashIndex);
  }
  return searchParam;
}

export function getQueryByKey(src: string, key: string) {
  const searchParam = getQueryString(src);
  const val = new URLSearchParams(searchParam).get(key);
  return val || "";
}
